import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { User } from '../types';

export function useUsers(filters: { page?: number; pageSize?: number; role?: string; search?: string } = {}) {
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(filters)) {
    if (val !== undefined && val !== '') params.set(key, String(val));
  }
  const q = params.toString();

  return useQuery({
    queryKey: ['users', filters],
    queryFn: () => api.get<User[]>(`/users${q ? `?${q}` : ''}`),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: string } & Record<string, unknown>) =>
      api.patch<User>(`/users/${id}`, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['users'] }); },
  });
}

type UserMutationOptions = { onSuccess?: () => void; onError?: (error: Error) => void };

export function useDeleteUser(options?: UserMutationOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/users/${id}`),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['users'] }); options?.onSuccess?.(); },
    onError: (error) => { options?.onError?.(error); },
  });
}
